export const CREATE_BULK_LOCATIONS_REQUESTED = 'CREATE_BULK_LOCATIONS_REQUESTED';
export const CREATE_BULK_LOCATIONS_SUCCEEDED = 'CREATE_BULK_LOCATIONS_SUCCEEDED';
export const CREATE_LOCATION_REQUESTED = 'CREATE_LOCATION_REQUESTED';
export const CREATE_LOCATION_SUCCEEDED = 'CREATE_LOCATION_SUCCEEDED';
